/** The five broadcast desk commentators — shared across homepage sections. */
export const COMMENTATORS = [
  { key: "grak_ironjaw", name: "Grak Ironjaw" },
  { key: "skrix_dataclack", name: "Skrix Dataclack" },
  { key: "vaeltharion_the_unimpressed", name: "Vaeltharion" },
  { key: "midge_tumblebottom", name: "Midge Tumblebottom" },
  { key: "mortifax_greel", name: "Mortifax Greel" },
] as const
